<template>
	<div class="config-page" v-loading.fullscreen="loading">
		<PageBar>
			<div class="page-bar">
				<i class="el-icon-back" />
				<span class="colse" @click="handleCancel">取消</span>
				|
				<span class="add">{{ $route.query.task_id ? '复制任务' : '创建任务' }}</span>
				<!-- <el-button type="primary" @click="getFormData"><span class="save">提交</span></el-button> -->
				<el-popover placement="right-start" title="存在以下问题点，请检查修改后重试：" width="400" trigger="manual"
					v-model="popoverVisible">
					<div class="tip-list">
						<p v-for="(item, index) in errorFormList" :key="index">
							{{ index + 1 }}、{{ item }}
						</p>
						<div class="btn" style="text-align: center;"><el-button
								@click="popoverVisible = !popoverVisible" type="primary"
								size="mini"><span>关闭</span></el-button></div>
					</div>
					<el-button slot="reference" :loading="previewLoading" type="primary" size="mini"
						@click="toPreviewPage"
						v-matomo="{ behaviorCategory: '荣耀(批量搭建)', name: $route.query.task_id ? '列表(复制-生成预览)' : '批量创建(生成预览)' }">生成预览</el-button>
				</el-popover>
				<el-button type="primary" id="ads_clear" size="mini" @click="handleClear"
					v-show="false">清空校验</el-button>
			</div>
		</PageBar>
		<FormPage v-if="!loading" class="mt40" ref="FormPage" :root="root" :config="config" />
	</div>
</template>

<script>

import FormPage from '../../../configuration/formPage.vue'
import { resetData } from './FormPageDatas'
import { getConfigApi, getBatchTaskInfoApi, postBatchHonorPreviewApi } from '@/api'
import { mockFormData } from './mock'
import PageBar from '@/components/PageBar/index.vue'
export default {
	name: "ConfigPage",
	components: {
		FormPage,
		PageBar
	},
	props: {
		pageParams: {
			type: Object,
			default: () => {
				return {};
			},
		}
	},
	data() {
		return {
			root: {},
			config: {},
			loading: false,
			errorFormList: [],//表单验证错误数据
			popoverVisible: false,//
			previewLoading: false,
		}
	},
	async created() {
		this.getConfig().then(async () => {
			let store_info = window.localStorage.getItem('honor_batch')
			if (!store_info) {
				if (this.pageParams.id) {
					//复制任务
					await this.getBatchTaskInfo()
				} else {
					//创建任务
					let deep_clone_mockFormData = _.cloneDeep(mockFormData)
					let new_data = deep_clone_mockFormData.map(item => {
						let newItem = _.cloneDeep(item);
						if (newItem.payload?.props?.defaultData) {
							newItem.payload.props.defaultData = this.config[newItem.payload.field] ? this.config[newItem.payload.field] : newItem.payload?.props?.defaultData
						}
						return { ...newItem };
					})
					this.root = resetData(new_data)
				}
			} else {
				// 上一步 取存的信息
				let parse_data = JSON.parse(store_info)
				await this.setBatchTaskInfo(parse_data)
				window.localStorage.removeItem('honor_batch')

			}
			this.loading = false
		}).catch(() => {
			this.loading = false
		})
	},
	methods: {
		async getBatchTaskInfo() {
			try {
				const { data } = await getBatchTaskInfoApi({ plat_id: 11, task_id: this.pageParams.id });
				await this.setBatchTaskInfo(data)
			} catch (error) {
				this.$message.error(error.message)
			}
		},
		async setBatchTaskInfo(obj) {
			let keys = Object.keys(obj)
			let deep_clone_mockFormData = _.cloneDeep(mockFormData)
			let new_data = deep_clone_mockFormData.map(item => {
				let newItem = _.cloneDeep(item);
				if (newItem.payload?.props?.defaultData) {
					newItem.payload.props.defaultData = this.config[newItem.payload.field] ? this.config[newItem.payload.field] : newItem.payload?.props?.defaultData
				}
				newItem.payload.value = obj[newItem.payload.field] ? obj[newItem.payload.field] : newItem.payload.value

				return { ...newItem };
			})
			this.root = resetData(new_data)
		},
		getConfig() {
			return new Promise((resolve, reject) => {
				this.loading = true;
				getConfigApi({ plat_id: 11 }).then(res => {
					const config = {}
					res.data.list.forEach(item => {
						item.label = item.param_name;
						if (config[item.type]) {
							config[item.type].push(item)
						} else {
							config[item.type] = [item]
						}
					});
					console.log('config', config);
					this.config = config;
					// 保存配置 在全局变量中
					window.batch_config_wk = null
					window.batch_config_wk = config;
					resolve()
				}).catch(err => {
					this.$message.error(err.info)
					reject()
				})
			})
		},
		convertTimeToBinary(timeArray) {
			// 初始化一个长度为48的数组，全部填充0
			let binaryArray = new Array(48).fill(0);

			// 将时间转换为分钟数
			function timeToMinutes(time) {
				const [hours, minutes] = time.split(':').map(Number);
				return hours * 60 + minutes;
			}

			// 将分钟数转换为数组索引
			function minutesToIndex(minutes) {
				return Math.floor(minutes / 30);
			}

			// 获取开始和结束时间
			const startTime = timeToMinutes(timeArray[0]);
			const endTime = timeToMinutes(timeArray[1]);

			// 计算开始和结束的索引
			const startIndex = minutesToIndex(startTime);
			const endIndex = minutesToIndex(endTime);

			// 填充时间段
			for (let i = startIndex; i < endIndex; i++) {
				binaryArray[i] = 1;
			}

			// 转换为字符串
			return binaryArray.join('').repeat(7);
		},
		findNullAppId(params) {
			let result = []
			const { app_id, creative_size_id, product_config_list, modalForm } = params
			const [ packageSelectData ] = modalForm;
			let sort_app_id = _.sortBy(_.uniq(app_id))
			let product_config_list_id = _.sortBy(_.uniq(product_config_list.map(v => v.app_id)))
			let conversionSelectData_id = modalForm[0] ? _.sortBy(_.uniq(modalForm[0].map(v => v.app_id))) : []
			let materialSelectData_id = modalForm[1] ? _.sortBy(_.uniq(modalForm[1].map(v => v.app_id))) : []
			let packageSelectData_id = modalForm[2] ? _.sortBy(_.uniq(modalForm[2].map(v => v.app_id))) : []

			// list是个数组 判断  是否为空
			let materialSelectData_creative_size_ids = modalForm[1] ? modalForm[1].some(v => v?.list?.length === 0) : true

			// modalForm[2]示例 [{app_id: "966",cover_list: [], creative_size_id: "1372290574429958144", img_list: [], video_list: []}]
			// 判断video_list img_list， 如果都是空数组，则返回false
			let packageSelectData_creative_size_ids = modalForm[2] ? modalForm[2].some(v => v?.img_list?.length === 0 && v?.video_list?.length === 0) : true

			let creative_size_id_sort =_.sortBy(_.uniq(creative_size_id))
			console.log('creative_size_id_sort', creative_size_id_sort, materialSelectData_creative_size_ids, packageSelectData_creative_size_ids)
			if (!_.isEqual(sort_app_id, product_config_list_id)) {
				result.push('产品配置')
			}
			if (packageSelectData.some(v=>!v.list.length)) {
				result.push('定向包')
			}
			if (!_.isEqual(sort_app_id, materialSelectData_id) || materialSelectData_creative_size_ids) {
				result.push('转化出价')
			}
			if (!_.isEqual(sort_app_id, packageSelectData_id) || packageSelectData_creative_size_ids) {
				result.push('创意组')
			}
			return result
		},
		toPreviewPage() {
			this.$refs.FormPage.getFormData().then((params) => {
				if(!params) return
				this.previewLoading = true
				if (params?.time_period_type === 'TIME_PERIOD_ALL') {
					params['time_period'] = '111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111'
				} else if (params?.time_period_type === 'TIME_PERIOD_DAY_SPECIFIC') {
					let time_period = params.times_fixed
					params['time_period'] = this.convertTimeToBinary(time_period)
				} else if (params?.time_period_type === 'TIME_PERIOD_HOUR_SPECIFIC') {
					params['time_period'] = params.times_drop
				}

				const [target_list, bid_list, idea_list] = params?.modalForm || [];
				params.target_list = target_list;
				params.bid_list = bid_list;
				params.idea_list = idea_list;

				console.log('提交结果', params)
				let result = this.findNullAppId(params)
				if (result.length) {
					this.errorFormList = result
					this.popoverVisible = true
					this.previewLoading = false
					return
				}

				postBatchHonorPreviewApi(params).then(res => {
					this.$message.success(res.info)
					window.localStorage.setItem('honor_batch', JSON.stringify(params))
					this.$emit('to-page', 'PreviewPage', { id: res.data.task_id })
				}).catch(err => {
					this.errorFormList = [err.info]
					this.popoverVisible = true
				}).finally(() => {
					this.previewLoading = false
				})
			}).finally(err => {
				this.popoverVisible = false
			})
		},
		handleCancel() {
			this.$confirm('取消后不会保存当前内容，确认要取消吗？','温馨提示',{
				confirmButtonText: '确认取消',
				cancelButtonText: '关闭',
				type: 'warning',
			}).then(()=>{
				this.$emit('to-page', 'ListPage')
			})
		},
		handleClear() {
			let ele = document.getElementById('ads_clear')
			let data_field = ele.dataset.field
			this.$refs.FormPage.clearFormValidate([...data_field])
		}
	},
	mounted() {
        window.onbeforeunload = function(){
            return "确定要离开吗？系统可能不会保存您所做的更改";
        }
    },
    beforeDestroy() {
        window.onbeforeunload = null;
    },

}
</script>

<style lang="scss" scoped>
.config-page {
	padding-top: 40px;
	padding-left: 10px;
	padding-right: 10px;
	background-color: #fff;

	.page-bar {
		background: #fff;
		height: 44px;
		border-radius: 6px;
		border-bottom: 1px solid #e2e2e2;
		line-height: 44px;
		font-size: 14px;

		.colse {
			margin-right: 6px;
			cursor: pointer;
		}

		.add {
			font-weight: bold;
			margin-left: 6px;
			margin-right: 30px;
		}

		.save {
			padding: 0 30px;
		}
	}
}
</style>